<mat-card class="task-viewer-tile">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="tile-property">
          <strong>Name</strong>
          <div>{{ task.name }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-xs-12">
        <div class="tile-property">
          <strong>Started</strong>
          <div>{{ task.timestamp | date:'medium' }}</div>
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <div class="tile-property">
          <strong>Last Update</strong>
          <div>{{ task.lastUpdate | date:'medium' }}</div>
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <div class="tile-property">
          <strong>Files</strong>
          <div>{{ task.taskBlocks.length }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <mat-progress-bar *ngIf="task.status === 0" mode="query"></mat-progress-bar>
      <mat-progress-bar *ngIf="task.status === 1 && task.progress != 100" mode="determinate" [value]="task.progress"></mat-progress-bar>
      <mat-progress-bar *ngIf="task.status === 1 && task.progress === 100" mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
  <div class="tile-divider">
    <mat-divider></mat-divider>
  </div>
  <div class="container-fluid">
    <div class="row" style="margin-top: 15px;">
      <div class="tile-toolbar row">
        <div class="tile-property col-lg-6 col-xs-12">
          <strong>Status</strong>
          <div>{{ getStatus(task) }}</div>
          <mat-spinner [diameter]="25" *ngIf="task.status === 1"></mat-spinner>
        </div>
        <div class="tile-buttons col-lg-6 col-xs-12" style="display: flex; justify-content:flex-end">
          <button (click)="getDownloadLink($event)" mat-raised-button color="accent" [disabled]="task.status != 2">
            <fa-icon [icon]="faDownload"></fa-icon>
            <span class="task-viewer-tile-action-caption">
              Download
            </span>
          </button>
          <button (click)="openDetailsModal($event)" mat-raised-button color="primary">
            <fa-icon [icon]="faList"></fa-icon>
            <span class="task-viewer-tile-action-caption">
              Details
            </span>
          </button>
          <button (click)="cancelTaskRequest($event)" mat-raised-button color="primary">
            <fa-icon [icon]="faTrashCan"></fa-icon>
            <span class="task-viewer-tile-action-caption">
              Cancel
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-card>
